/* global Backbone */

App.Routers.Reports = Backbone.Router.extend({
  routes: {
    'venue/:venueid/bookings/:filterType/:filterDate': 'bookings',
    'venue/:venueid/bookings/:filterType/:filterDate/:dialogType/:dialogTypeId': 'bookings',
    'venue/:venueid/bookings': 'bookings',
    'venue/:venueid/sales/:periodGranularity/:startDate': 'sales',
    'venue/:venueid/sales': 'sales',
    'venue/:venueid/transactions': 'transactions',
    'venue/:venueid/transactions/:date': 'transactions',
    'venue/:venueid/salesReports': 'salesReports',
    'venue/:venueid/salesReports/*reportParams': 'salesReports',
    'venue/:venueid/clientReports': 'clientReports',
    'venue/:venueid/clientReports/*reportParams': 'clientReports',
    'venue/:venueid/posReports/': 'posReports',
    'venue/:venueid/posReports/*reportParams': 'posReports',
    'venue/:venueid/selfEmploymentReports': 'selfEmploymentReports',
    'venue/:venueid/selfEmploymentReports/': 'selfEmploymentReports',
  },

  bookings: function bookings(venueId, _filterType, _filterDate, dialogType, dialogTypeId) {
    App.mainViewOptions = {};

    if (dialogType && dialogTypeId) {
      App.mainViewOptions.initialDialog = {
        type: dialogType,
        id: dialogTypeId,
        // Used for venueId check and redirect back from login to correct URL
        venueId: venueId,
        dialogUrl: document.URL,
      };
    }

    App.initVenue(venueId);
  },

  sales: function sales(venueId) {
    App.mainViewOptions = {};
    App.initVenue(venueId);
  },

  transactions: function transactions(venueId) {
    App.mainViewOptions = {};
    App.initVenue(venueId);
  },

  salesReports: function salesReports(venueId) {
    App.mainViewOptions = {};
    App.initVenue(venueId);
  },

  clientReports: function clientReports(venueId) {
    App.mainViewOptions = {};
    App.initVenue(venueId);
  },

  posReports: function posReports(venueId) {
    App.mainViewOptions = {};
    App.initVenue(venueId);
  },

  selfEmploymentReports: function selfEmploymentReports(venueId) {
    App.mainViewOptions = {};
    App.initVenue(venueId);
  },
});
